import type { MemoryDictionary } from '../memoryContract'

const memory = {
  page: {
    eyebrow: '기업 마케팅 메모리',
    title: '마케팅 메모리',
    intro: '이곳은 자료 보관함이 아닙니다. Navigator가 현재 이 기업을 어떻게 이해하는지 보여 주고, 진단·실행·게시·회고가 하나의 공통된 이해에서 이어지도록 합니다.',
    updated: '기업 메모리가 업데이트되었습니다',
    lastUpdated: '마지막 업데이트 · {date}',
    reportIssue: '잘못 이해한 부분이 있어요',
  },
  tabs: {
    overview: '현재 이해',
    cognition: '기업 인식',
    knowledge: '아는 것',
    strategy: '실행 방식',
    identity: '정체성',
    connections: '연결',
  },
  cognition: {
    title: 'Navigator가 이 기업을 이해한 과정', body: '확인된 초기 프로필과 전체 기업 연구를 언제든 다시 볼 수 있습니다. 일회성 온보딩 화면이 아니라 프로젝트에 남는 인식 자산입니다.', assets: '개 인식 자산', loading: '기업 인식 불러오는 중', loadingBody: '이 프로젝트의 확인된 프로필과 기업 연구를 가져오고 있습니다.', error: '기업 인식을 일시적으로 불러올 수 없습니다', errorBody: '다른 기업 메모리는 변하지 않았습니다. 다시 불러와 주세요.', profileEyebrow: '초기 프로필', profileTitle: '확인된 기업 프로필', researchEyebrow: '기업 연구', researchTitle: '연구 종합 결과', notCreated: '미생성', completed: '완료', confirmedAt: '확인 · {date}', generatedAt: '생성 · {date}', profileEmpty: '확인된 초기 기업 프로필이 없습니다.', researchEmpty: '기업 연구가 아직 완료되지 않았습니다.', summary: '연구 결론', facts: '사실 {count}개', hypotheses: '가설 {count}개', unknowns: '미확인 {count}개', candidates: '후보 {count}개', findings: '핵심 발견 {count}개 열기', evidence: '사실·가설·미확인 항목 보기', knownFacts: '확인된 사실', hypothesisTitle: '검증할 가설', unknownTitle: '미확인 및 충돌', fields: { brand_identity: '브랜드 정체성', domain_footprint: '공식 사이트와 도메인', product_lines: '주요 제품 또는 제품군', markets_languages: '목표 시장과 언어', buyer_types: '대표 고객 또는 구매자', competitors: '초기 경쟁 후보', public_content_foundation: '공개 콘텐츠 기반', website_shape: '공식 사이트 상태', company_type: '초기 기업 유형' },
  },
  common: {
    confirmed: '확인됨',
    awaitingConfirmation: '확인 대기',
    awaitingEvidence: '근거 추가 필요',
    continueObserving: '계속 관찰',
    inProgress: '진행 중',
    connected: '연결됨',
    view: '보기',
    close: '닫기',
    cancel: '취소',
    retry: '다시 시도',
    later: '나중에',
  },
  contentLanguage: {
    original: '원문 · {language}',
    unchangedHint: '기업 사실, 브랜드 원문 및 증거 인용문은 원래 언어로 유지됩니다.',
  },
  overview: {
    currentUnderstanding: 'Navigator가 현재 이해한 {company} · 확인 대기',
    viewBrandDirection: '브랜드 방향 확인',
    suggestCorrection: '수정 제안',
    sharedUnderstanding: '모든 마케팅 업무를 하나의 공통된 이해에서 이어갑니다',
    map: {
      knowledge: '아는 것',
      knowledgeHint: '사실과 시장',
      strategy: '실행 방식',
      strategyHint: '전략과 실행',
      identity: '정체성',
      identityHint: '가치와 선택',
      connections: '연결',
      connectionsHint: '행동과 결과',
    },
    cards: {
      knowledgeTitle: '아는 것',
      knowledgeBody: '확인된 사실, 시장의 반응, 더 알아야 할 내용을 확인합니다.',
      strategyTitle: '실행 방식',
      strategyBody: '이번 단계의 마케팅 방향, 실행 현황, 다음 제안을 확인합니다.',
      identityTitle: '정체성',
      identityBody: '시장이 기억해야 할 핵심 메시지, 가치 축, 모듈의 역할을 확인합니다.',
      connectionsTitle: '연결',
      connectionsBody: '각 성과가 어디에서 시작되었고 무엇을 바꾸었으며 다음 단계에 어떻게 반영되는지 봅니다.',
      enter: '열기 →',
      confirmedModules: '{count}개 메시지 확인됨',
      liveOutcomes: '성과 {count}개',
    },
    learning: {
      eyebrow: '최근 학습',
      title: '최근에 배운 것',
      body: 'Navigator는 실제로 효과가 있었던 표현과 더 검증해야 할 방향을 기억해 다음 업무를 이번 결과에서 이어갑니다.',
      adopted: '사용 중',
      observing: '검증 계속',
    },
  },
  knowledge: {
    eyebrow: '아는 것',
    title: '확인된 것과 더 알아야 할 것',
    body: '제품 사실, 시장 반응, 아직 부족한 정보를 확인하고 필요할 때 Navigator의 이해를 바로잡을 수 있습니다.',
    confirmedFacts: '공개 사실 {count}개 확인됨',
    search: '사실, 시장 반응 또는 지식 공백 검색',
    filter: {
      all: '전체',
      facts: '확인된 사실',
      market: '시장 반응',
      gaps: '지식 공백',
      outcomes: '성과',
    },
    addMaterial: '자료 추가',
    category: {
      positioning: '제품 포지셔닝',
      specification: '제품 사양',
      platforms: '플랫폼 및 버전',
      marketSignal: '시장 반응',
      gap: '지식 공백',
      outcome: '성과',
    },
    source: {
      official: '공식 웹사이트',
      aiMonitoring: 'AI 답변 모니터링',
      awaitingSamples: '추가 샘플 대기',
      humanReview: '사람의 검토',
    },
    action: {
      viewBasis: '근거 보기',
      viewFacts: '원본 사실 {count}개 보기',
      viewAnswer: '이 답변 보기',
      viewMissing: '부족한 정보 보기',
      viewLearning: '배운 내용 보기',
    },
    status: {
      confirmed: '확인됨',
      moreEvidence: '근거 추가 필요',
      passedReviews: '검토 {count}회 통과',
    },
    noMatchTitle: '일치하는 메모리가 없습니다',
    noMatchBody: '다른 키워드를 입력하거나 전체 유형을 표시하세요.',
  },
  strategy: {
    eyebrow: '이번 단계 계획',
    title: '이번 단계의 마케팅을 어떻게 추진할지',
    body: '현재 목표, 진행 중인 업무, 참여가 필요한 항목, 다음 제안을 한곳에서 확인할 수 있습니다.',
    responsibilitySummary: 'Navigator 담당 {owned}개 / 협업 필요 {collaborative}개',
    directionAwaiting: '이번 단계 마케팅 방향 · 확인 대기',
    emptyTitle: '이번 단계의 방향이 아직 확정되지 않았습니다',
    emptyBody: 'Navigator는 실행 기록을 전략으로 가장하지 않습니다. 먼저 단계 목표와 방향을 확인하세요.',
    workEmptyTitle: 'Navigator가 진행할 업무가 아직 없습니다',
    workEmptyBody: '전략이 확인되고 실행 계획으로 전환되면 여기에 표시됩니다.',
    guidanceEmptyTitle: '팀과 함께할 안내 사항이 아직 없습니다',
    guidanceEmptyBody: '전략에 Navigator의 실행 범위를 벗어나는 업무가 필요할 때만 표시됩니다.',
    brief: {
      goal: '이번 단계의 목표',
      message: '시장이 기억해야 할 것',
      reviewWhen: '방향을 다시 검토할 때',
    },
    journey: {
      goal: '목표 정하기',
      goalHint: '누구에게 어떤 변화를 만들지',
      theme: '주제 정하기',
      themeHint: '모든 콘텐츠에 하나의 공통된 초점 부여',
      work: '업무 추진',
      workHint: '콘텐츠, 페이지, 게시 및 협업',
      feedback: '반응 확인',
      feedbackHint: 'AI 답변, 리드, 고객의 목소리',
      next: '다음 단계 결정',
      nextHint: '계속, 조정 또는 방향 전환',
    },
    navigatorLed: {
      eyebrow: 'Navigator 담당',
      title: 'Navigator가 진행합니다',
      body: '다음 업무는 방향 수립부터 게시와 회고까지 Navigator가 계속 추진합니다.',
      count: '업무 {count}개',
      positioningTitle: '이번 단계의 핵심 주장과 경쟁 위치 정립',
      positioningBody: '구매자가 실제로 중요하게 여기는 질문에서 출발해 핵심 가치, 모듈 역할, 선택 이유를 명확히 합니다.',
      contentTitle: '전략을 게시 가능한 콘텐츠로 전환',
      contentBody: '제품 페이지, FAQ, 구매 가이드, 비교 콘텐츠, 다국어 페이지를 지속적으로 제작합니다.',
      machineTitle: '웹사이트와 AI가 새 콘텐츠를 함께 이해하도록 구성',
      machineBody: '기존 웹사이트에 탐색 경로, 페이지 관계, 기계 판독 정보를 추가합니다.',
      publishTitle: '게시 후 모든 성과가 정상적으로 보이는지 확인',
      publishBody: '허용된 범위에서 수동, 협업 또는 자동 게시를 진행하고 페이지와 검색 진입점을 확인합니다.',
      reviewTitle: '시장 반응을 추적하고 다음 단계 준비',
      reviewBody: 'AI 답변, 리드, 고객 피드백을 바탕으로 계속할 방향과 조정할 방향을 판단합니다.',
      completed: '완료',
      pagesOnline: '{count}페이지 게시 중',
      ongoing: '계속 업데이트',
      connected: '연결됨',
      monitoring: '관찰 중',
    },
    collaboration: {
      eyebrow: '팀과 함께',
      title: '본인 또는 팀의 참여가 필요합니다',
      body: 'Navigator가 방향과 콘텐츠를 준비합니다. 시작 시점을 정하면 담당 팀이 실행합니다.',
      socialTitle: '{channels} 발행',
      socialBody: 'Navigator가 주제, 발행 주기, 콘텐츠 변형안을 준비하고 사용자가 확인 후 게시합니다.',
      socialStatus: '함께 진행',
      mediaTitle: '유료 미디어',
      mediaBody: 'Navigator가 타깃, 주제, 소재를 제안하고 미디어 팀이 예산과 집행을 관리합니다.',
      mediaStatus: '계정 필요',
      prTitle: 'PR, 이벤트 및 파트너십',
      prBody: 'Navigator가 주제, 시기, 협업 방향을 제안하고 본인이나 담당 팀이 대외 연락을 진행합니다.',
      prStatus: '팀 참여 필요',
    },
    results: {
      eyebrow: '시장의 반응',
      title: '다음 단계는 실제 반응으로 결정합니다',
      body: 'Navigator는 시장이 브랜드를 어떻게 말하는지, 어떤 고객이 다가오는지, 왜 선택하거나 망설이는지를 함께 살펴봅니다.',
      aiTitle: 'AI가 브랜드를 어떻게 말하는지',
      aiBody: '브랜드 언급 여부, 추천 방식, 함께 등장하는 경쟁사, 인용 출처를 계속 추적합니다.',
      aiAction: '계속 모니터링 · 최신 평가 보기 →',
      leadsTitle: '어떤 고객이 다가오고 있는지',
      leadsBody: '리드 출처, 구매자 질문, 후속 진행을 종합해 마케팅이 적합한 사람을 데려오는지 판단합니다.',
      leadsAction: '리드 연결됨 · 변화 보기 →',
      surveyTitle: '고객이 선택하거나 망설이는 이유',
      surveyBody: '어떤 표현이 신뢰를 만들었는지, 무엇이 여전히 불명확한지, 최종 결정에 무엇이 영향을 주었는지 직접 묻습니다.',
      surveyAction: '언제든 시작 가능 · 설문 만들기 →',
    },
    recommendation: {
      continue: '계속 권장',
      adjust: '조정 권장',
      schedule: '일정 대기',
    },
    methods: {
      eyebrow: 'Navigator가 배운 것',
      title: 'Navigator가 익힌 업무 원칙',
      body: '실제 업무와 사람의 판단에서 얻은 원칙이 다음 전략과 콘텐츠에 계속 반영됩니다.',
      count: '{active}개 사용 중 / {observing}개 검증 중',
      search: '원칙 검색',
      filterAll: '전체',
      filterActive: '사용 중',
      filterObserving: '검증 중',
      expression: '표현 원칙',
      competition: '경쟁 원칙',
      promise: '약속 원칙',
      inUse: '사용 중',
      validating: '검증 중',
      impact: '업무에 미치는 영향 보기',
      scope: '적용 범위 보기',
      validation: '추가 검증 항목 보기',
      emptyBody: '여기에 표시할 만큼 근거가 충분한 업무 원칙이 아직 없습니다.',
    },
  },
  identity: {
    eyebrow: '시장에 어떻게 기억되고 싶은지',
    title: '{company}가 어떻게 이해되기를 원하는지',
    body: '시장이 가장 먼저 기억해야 할 것과 기업의 제품과 역량이 그 인식을 어떻게 뒷받침하는지 확인합니다.',
    confirmedModules: '모듈 메시지 {count}개 확인됨',
    coreAwaiting: '핵심 메시지 · 확인 대기',
    confirm: '이 메시지 확인',
    revise: '수정 제안',
    usage: '사용 위치 보기',
    awaitingDecision: '결정 대기',
    notActive: '핵심 메시지는 아직 적용되지 않았습니다',
    afterConfirm: '확인하면 Navigator가 웹사이트, 콘텐츠, 향후 마케팅 활동에 일관되게 사용합니다.',
    pillarAwaiting: '확인 필요',
    modulesEyebrow: '확인된 모듈 메시지',
    modulesTitle: '제품과 역량이 핵심 가치를 뒷받침하는 방식',
    modulesCount: '{count}개 확인됨',
    moduleAction: '확인됨 · 전체 메시지 보기',
    noCoreTitle: '핵심 메시지가 아직 형성되지 않았습니다',
    noCoreBody: '확인된 기업 자료와 사람의 의도가 있어야 Navigator가 핵심 메시지를 제안할 수 있습니다.',
    noModulesBody: '확인된 제품 및 역량 메시지가 여기에 표시됩니다.',
  },
  connections: {
    eyebrow: '한 단계에서 다음 단계로',
    title: '모든 행동이 다음 실행의 정확도를 높입니다',
    body: '이전 단계에서 무엇을 했고 시장이 어떻게 반응했으며 그 결과가 다음 단계를 어떻게 바꾸는지 볼 수 있습니다.',
    onlineOutcomes: '게시 중인 성과 {count}개',
    journeyEyebrow: '하나로 이어지는 여정',
    journeyTitle: '판단에서 실행으로, 결과에서 다음 단계로',
    steps: {
      stage: '단계 파악',
      stageHint: '비즈니스 목표, 구매자 질문, 인식 차이',
      strategy: '전략 수립',
      strategyHint: '단계별 주제, 경쟁 위치, 성공 기준',
      work: '업무 추진',
      workHint: '콘텐츠, 페이지, 게시 및 협업 구성',
      results: '결과 확인',
      resultsHint: 'AI 답변, 리드, 고객 설문',
      next: '다음 단계',
      nextHint: '계속, 조정 또는 방향 전환을 결정하고 학습을 보존',
    },
    note: 'Navigator는 AI 답변, 리드, 고객 피드백을 함께 판단합니다. 효과가 있었던 방향은 이어가고, 효과가 없었던 시도도 기억해 같은 시행착오를 반복하지 않습니다.',
    recentTitle: '최근 완료된 전체 실행',
    recentBody: '구매자 질문에서 이중 언어 가이드 게시까지, 그리고 그 결과를 다음 콘텐츠에 반영하기까지의 흐름입니다.',
    noRecentBody: '완전한 실행 계보가 아직 기록되지 않았습니다.',
    viewProcess: '전체 과정 보기',
    accumulatedTitle: 'Navigator가 축적한 것',
    accumulatedBody: '이 기록 덕분에 다음 업무를 매번 처음부터 시작하지 않고 기존 경험에서 이어갈 수 있습니다.',
    stats: {
      live: '게시 중인 성과',
      attempts: '기록된 시도',
      judgments: '경험 판단',
      actions: '완료된 실행',
    },
  },
  airlockGap: {
    eyebrow: 'Airlock 게시에서 이동',
    title: 'Airlock 답변에 필요한 기업 근거 보완',
    subject: '보완할 주제',
    status: '현재 상태',
    statusPending: '자료 추가 대기',
    statusQueued: '자료 제출됨 · 처리 대기',
    statusSynced: '동기화됨 · 다시 테스트할 수 있음',
    flowLabel: '지식 보완 절차',
    flow: {
      supply: '사실 추가',
      classify: '자료 분류',
      confirm: '지식 확인',
      retest: '돌아가 재검증',
    },
    reason: {
      missing_knowledge: '승인된 기업 자료에 이 주제의 신뢰할 수 있는 답이 아직 없습니다. 원본 근거나 정확한 업무 사실을 추가해 주세요.',
      conflicting_knowledge: '기존 자료의 설명이 서로 다릅니다. 현재 유효한 공식 입장과 대체되는 내용을 추가해 주세요.',
      knowledge_not_public: '내부 정보는 있지만 Airlock에서 공개적으로 사용할 수 없습니다. 공개 가능한 설명을 추가하거나 안전 경계를 선택하기 위해 돌아가세요.',
      knowledge_not_synced: '확인된 지식이 이 Airlock의 사용 범위에 아직 동기화되지 않았습니다. 기존 지식을 확인하거나 누락된 근거를 추가해 주세요.',
      not_applicable_review: '이 주제에는 업무 판단이 필요합니다. 적용되면 사실을 추가하고, 적용되지 않으면 Airlock으로 돌아가 확인해 주세요.',
    },
    queuedBody: '추가한 내용이 자료 처리 대기열에 들어갔습니다. 확인된 지식이 되어 이 Airlock에 동기화될 때까지 게시 차단 항목은 열려 있습니다.',
    addStatement: '사실 설명 추가',
    submitted: '사실 설명 제출됨',
    reviewKnowledge: '기존 지식 보기',
    returnToAirlock: 'Airlock 게시로 돌아가기',
    correctionTitle: '이 Airlock 지식 공백에 근거 추가',
    correctionBody: '검증 가능한 업무 사실과 가능한 경우 출처를 작성해 주세요. 제출만으로 공개되거나 공백이 자동 해소되지는 않습니다.',
    correctionLabel: '업무 사실 또는 근거',
    correctionPlaceholder: '예: 표준 사양의 최소 주문 수량은 500개이며 출처는 2026년 현행 판매 정책입니다…',
    correctionSubmit: '처리 요청',
    queuedToast: '자료를 받았습니다. 지식 확인과 동기화가 끝날 때까지 Airlock 공백은 열린 상태로 유지됩니다.',
  },
  states: {
    loadingTitle: '기업 메모리를 모으는 중',
    loadingBody: 'Navigator가 사실, 전략, 실행, 결과 및 학습을 읽고 있습니다. 아직 읽지 못한 내용을 0 또는 존재하지 않는 것으로 처리하지 않습니다.',
    emptyEyebrow: '새 기업',
    emptyTitle: '이 기업의 메모리는 아직 시작되지 않았습니다',
    emptyBody: '먼저 웹사이트와 자료를 연결하세요. Navigator가 사전 조사를 하고 사용자의 판단이 필요한 부분만 가져옵니다.',
    connectMaterial: '첫 자료 연결',
    readWebsite: '웹사이트 먼저 읽기',
    errorEyebrow: '읽기 실패',
    errorTitle: '현재 기업 메모리를 읽을 수 없습니다',
    errorBody: '기존 메모리는 안전하며 빈 상태로 덮어쓰지 않습니다. 다시 시도하거나 마지막으로 신뢰할 수 있는 스냅샷을 확인하세요.',
    retry: '다시 읽기',
    lastSnapshot: '마지막 스냅샷 보기',
    snapshotUnavailable: '현재 세션에 사용할 수 있는 신뢰 스냅샷이 없습니다.',
    humanEyebrow: '결정이 필요합니다',
    humanTitle: '타당한 방향이 두 개 이상 발견되었습니다',
    humanBody: 'Navigator가 대신 선택하지 않습니다. 선택지를 비교하고 기업의 의도에 가장 맞는 표현을 확인하세요.',
    choose: '선택지 보기',
    later: '나중에',
    decisionDeferred: '결정은 대기 상태이며 방향은 변경되지 않았습니다.',
  },
  detail: {
    eyebrow: '메모리 상세',
    correct: '이 내용을 수정',
    source: '출처 보기',
    correctionTitle: 'Navigator의 이해 수정',
    correctionBody: '수정 내용은 새로운 입력으로 반영되며 확인된 사실이나 원본 출처를 조용히 덮어쓰지 않습니다.',
    correctionLabel: '수정 내용',
    correctionPlaceholder: '예: 구매자가 우리를 먼저 선택하는 이유는 장기적으로 통제할 수 있기 때문이지, 단순히 특정 기능이 더 편리해서가 아닙니다…',
    cancel: '취소',
    submit: '수정 제출',
    submitting: '제출 중…',
    correctionQueued: '수정 내용을 받았습니다. 분류를 마친 뒤 기업 메모리에 반영됩니다.',
    correctionFailed: '수정 내용을 제출하지 못했습니다.',
    fields: {
      id: '기록 ID',
      locale: '원문 언어',
      source: '출처',
      scope: '적용 범위',
      confidence: '신뢰도',
      status: '상태',
      question: '구매자 질문',
      platform: '플랫폼',
      output: '연결된 결과물',
    },
  },
} satisfies MemoryDictionary

export default memory
